import { useEffect, useState } from "react";

// Triggers a re-render every `intervalMs` milliseconds so time-sensitive UI
// (SLA tickers, "X minutes ago" labels) stays current without each card
// needing its own setInterval.
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState<number>(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
